$(function () {
  $('#wuqian .childMenu').hide();
  $("#wuqian .top-nav>li>a").on('click', function (e) {
    if (!$(this).attr("href")) {
      if ($(this).siblings('.childMenu').is(":hidden")) {
        $(this).siblings('.childMenu').show();
      } else {
        $(this).siblings('.childMenu').hide();
        window.scrollTo(0, 0)
      }
    }
  });
  window.onscroll = function () {
    if ($(document).scrollTop() > 100) {
      $('#to-top').addClass('position-top');
      $('#home,#fix-nav,#wuqian').addClass('fixed');
    } else {
      $('#to-top').removeClass('position-top');
      $('#home,#fix-nav,#wuqian').removeClass('fixed');
    }
  }
  $('#top').click(function () {
    $('html,body').animate({ scrollTop: 0 }, 1000)
  })
})


// WEBPACK FOOTER //
// ./src/assets/js/top-nav.js